import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import React from "react";
import Modal from "react-bootstrap/Modal";
import RefundChargeViewModel from "viewModels/callCenter/search/charges/refundChargeViewModel";
import { translateGeneral } from "utils/localizations";
import { RefundChargeForm } from "./refundChargeForm";
import RefundPreview from "./refundPreview";
import HeaderWithBackButton from "components/headerWithBackButton";
import RefundInformationPanel from "../refundInformationPanel";

export const RefundChargeView: ViewComponent<RefundChargeViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  const isButtonDisabled =
    (!vm.isAllowedToChangePaymentInformation && vm.paymentInformationRequired) || vm.busyWatcher.isBusy || vm.isRefundProcessed;

  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-md" centered>
      <Modal.Header closeButton={true}>
        {vm.secondStep ? (
          <HeaderWithBackButton level={4} back={{ action: () => vm.onBackClick() }} title={vm.translate("name")} />
        ) : (
          <Modal.Title>{vm.translate("name")}</Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        <RefundInformationPanel vm={vm} />
        <View vm={vm.alertsViewModel} useLifecycle={true} />
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {vm.secondStep ? <RefundPreview vm={vm} /> : <RefundChargeForm vm={vm} />}
        </LoaderOverlay>
        <ButtonToolbar className="justify-content-center">
          {vm.secondStep ? (
            <Button size="sm" type="reset" onClick={vm.onBackClick} variant="light">
              {translateGeneral("back")}
            </Button>
          ) : (
            <Button size="sm" type="reset" onClick={vm.requestClose} variant="light">
              {translateGeneral("cancel")}
            </Button>
          )}
          {vm.secondStep ? (
            <Button size="sm" type="submit" onClick={vm.onSubmit} disabled={!vm.canBeSubmitted}>
              {translateGeneral("confirm")}
            </Button>
          ) : (
            <Button size="sm" type="submit" onClick={vm.onSubmit} disabled={isButtonDisabled}>
              {translateGeneral("continue")}
            </Button>
          )}
        </ButtonToolbar>
      </Modal.Body>
    </Modal>
  );
});

registerView(RefundChargeView, RefundChargeViewModel);
